import React, { useEffect, useState } from "react"
import { TextInput, 
    ReferenceInput,
    SelectInput,
    required, 
    useDataProvider } from "react-admin"
import { Grid } from "@mui/material"
import { useTranslate } from "ra-core"
import { useController } from "react-hook-form"
import { EquipmentEntity } from "api/equipment/equipment.pb"
import DoubleSlider from "components/ui/forms/slider"

interface props {
    readonly: boolean
    newRecord: boolean
    equipment_ids?: string[]
}

function Properties(props: React.PropsWithChildren<props>): JSX.Element  {
    const { readonly, newRecord, equipment_ids } = props
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const [equipments, setEquipments] = useState<EquipmentEntity[]>([])
    const minP = Number(equipments[0]?.props?.min)
    const maxP = Number(equipments[0]?.props?.max)
    const unitP = equipments[0]?.props?.unit
    const [valueP, setValueP] = useState<[number,number]>([minP,maxP])
    const minT = Number(equipments[1]?.props?.min)
    const maxT = Number(equipments[1]?.props?.max)
    const unitT = equipments[1]?.props?.unit
    const [valueT, setValueT] = useState<[number,number]>([minT,maxT])

    useEffect(() => {
        if (!equipment_ids || equipment_ids.length === 0) {
            return
        }
        dataProvider.getMany('equipments', {
             ids: equipment_ids },
        )
        .then(({ data }) => setEquipments(data))
        .catch(() => setEquipments([]))
    }, [dataProvider, equipment_ids])

    useEffect(() => {
        setValueP([minP, maxP])
    }, [minP, maxP])

     useEffect(() => {
        setValueT([minT, maxT])
    }, [minT, maxT])

    if (equipments.length === 0) {
        return <></>
    }

    return (
        <>
            <Grid container>
                <Grid item xs={6}>
                    <fieldset style={{ border: '1px solid #bdbdbd', borderRadius: 8, padding: 14, margin: 0 }}>
                        <legend style={{ padding: '0 7px', fontWeight: 600, fontSize: 14 }}>
                            {translate('resources.devicesddt.fields.treshold_p')}
                        </legend>
                        <DoubleSlider min={minP} max={maxP} value={valueP} onChange={setValueP} unit={translate(`resources.units.values.${unitP}`)} readonly={readonly}/>
                    </fieldset>
                </Grid>
                <Grid item xs={6}>
                    <fieldset style={{ border: '1px solid #bdbdbd', borderRadius: 8, padding: 14, margin: 0 }}>
                        <legend style={{ padding: '0 7px', fontWeight: 600, fontSize: 14 }}>
                            {translate('resources.devicesddt.fields.treshold_t')}
                        </legend>
                        <DoubleSlider min={minT} max={maxT} value={valueT} onChange={setValueT} unit={translate(`resources.units.values.${unitT}`)} readonly={readonly}/>
                    </fieldset>
                </Grid>
            </Grid>
        </>
    )
}

Properties.defaultProps = {
    readonly: false,
    newRecord: false,
}

export default Properties
